/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {

    cartUpdatedEvents = ['cart:updated', 'ajaxProduct:added'];

    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout( async () => {
        await this.updateCart();
      }, 500);

        this.addEventListeners();
    }

    async getCart() {
        const response = await fetch('/cart.js');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
        }

    async updateCart() {

        const cart = await this.getCart();
        const cartTotal = cart.total_price || 0;
      let amountText = this.querySelector('.free-shipping--text span');
      let total = cartTotal
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');


      if (total < minimum) {
        percentage = total / minimum;

        if (amountText) {
          let remaining = minimum - total;
          let format = window.theme.settings.money_with_currency_format || '${{amount}}';
          amountText.innerHTML = window.theme.Currency.formatMoney(remaining, window.theme.settings.moneyFormat);
        }

        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
      } else {
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'none';
          this.fullText.style.display = 'block';
        }
      }

      this.style.setProperty('--percentage', percentage);
    }

    addEventListeners() {
      this.cartUpdatedEvents.forEach(eventName => {
        document.addEventListener(eventName, (event) => {
          this.updateCart();
        });
      });
    }

  }

  customElements.define('free-shipping', FreeShipping);
}
